import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader';
import { CustomerService } from '@/entities/CustomerService';
import GetMoneySteps from '@/entities/GetMoneySteps';

export const Component = () => {
  const navigate = useNavigate();
  const navigateCabinet = () => navigate('/auth');
  return (
    <>
      <PageHeader
        buttonId="how-get-money-page"
        title={<FormattedMessage defaultMessage="Как получить деньги" />}
        buttonTitle={<FormattedMessage defaultMessage="Получить деньги" />}
        buttonHandler={navigateCabinet}
      />
      <GetMoneySteps />
      <CustomerService />
    </>
  );
};

Component.displayName = 'HowGetMoneyPageLazy';
